import { render, staticRenderFns } from "./DeleteTeletag.vue?vue&type=template&id=704f179c"
import script from "./DeleteTeletag.vue?vue&type=script&lang=js"
export * from "./DeleteTeletag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports